export const roadLayerDefinition = {
    geometryType: 'esriGeometryPolygon',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 114.62715726199997,
        ymin: -34.902194700999985,
        xmax: 118.016416607,
        ymax: -28.779157684999973,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'name',
            type: 'esriFieldTypeString',
            alias: 'name',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'suffix',
            type: 'esriFieldTypeString',
            alias: 'suffix',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'totalarea',
            type: 'esriFieldTypeDouble',
            alias: 'totalarea',
            editable: true,
            nullable: true
        },
        {
            name: 'typecode',
            type: 'esriFieldTypeString',
            alias: 'typecode',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'roadid',
            type: 'esriFieldTypeInteger',
            alias: 'roadid',
            editable: true,
            nullable: true
        },
        {
            name: 'polygonids',
            type: 'esriFieldTypeString',
            alias: 'polygonids',
            editable: true,
            nullable: true,
            length: 1024
        }
    ]
};
